import { EApplication, EAxlePosition } from "@tm/models"

const getAxlePositionImageName = (axlePosition?: EAxlePosition) => {
    switch (axlePosition) {
        case EAxlePosition.allPositions:
            return "all-positions"
        case EAxlePosition.steer:
        case EAxlePosition.steerAllPositions:
            return "steer"
        case EAxlePosition.drive:
        case EAxlePosition.driveAllPositions:
            return "drive"
        case EAxlePosition.trailer:
        case EAxlePosition.trailerAllPositions:
            return "trailer"
        default:
            return null
    }
}

const getApplicationImageName = (application?: EApplication) => {
    switch (application) {
        case EApplication.long:
        case EApplication.longHaul:
            return "interregional"
        case EApplication.regional:
        case EApplication.city:
            return "regional"
        case EApplication.construction:
            return "off-road"
        case EApplication.mixed:
            return "mixed-on-off-road"
        default:
            return null
    }
}

export const getTruckTyreIconPath = (application?: EApplication, axlePosition?: EAxlePosition) => {
    const applicationImageName = getApplicationImageName(application)
    const axlePositionImageName = getAxlePositionImageName(axlePosition)

    if (!applicationImageName || !axlePositionImageName) {
        return null
    }

    return `/styles/base/images/truck-${applicationImageName}-${axlePositionImageName}.png`
}
